import { render, staticRenderFns } from "./Rute.vue?vue&type=template&id=460f2fa9&scoped=true"
import script from "./Rute.vue?vue&type=script&lang=js"
export * from "./Rute.vue?vue&type=script&lang=js"
import style0 from "./Rute.vue?vue&type=style&index=0&id=460f2fa9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460f2fa9",
  null
  
)

export default component.exports